<template>
  <div
    v-if="applicantProfile"
    id="applicant-show-tab-dashboard"
    class="applicant-show-tab"
  >
    <!-- <ValidationObserver ref="PersonalData" tag="form">
      <PersonalData v-model="internalValue" />
    </ValidationObserver>
    <div style="text-align:right;">
      <vs-button class="mt-3" @click="save()">Speichern</vs-button>
    </div> -->
    <div class="vx-row w-full">
      <div class="vx-col w-full md:w-1/3">
        <div class="applicant-show-tab-detail">
          <div class="applicant-show-tab-detail-headline">Mobilität</div>
          <div class="applicant-show-tab-detail-content">
            <div
              v-if="applicantProfile.ownCar"
              class="applicant-show-tab-detail-badge"
            >
              <i class="fas fa-car"></i>
            </div>
            <div
              v-if="applicantProfile.mobilityPublicTransport"
              class="applicant-show-tab-detail-badge"
            >
              <i class="fas fa-subway"></i>
            </div>
            <div
              v-if="applicantProfile.mobilityMotorcycle"
              class="applicant-show-tab-detail-badge"
            >
              <i class="fas fa-motorcycle"></i>
            </div>
            <div
              v-if="applicantProfile.mobilityBicycle"
              class="applicant-show-tab-detail-badge"
            >
              <i class="fas fa-bicycle"></i>
            </div>
            <div
              v-if="
                !applicantProfile.mobilityBicycle &&
                  !applicantProfile.mobilityMotorcycle &&
                  !applicantProfile.mobilityPublicTransport &&
                  !applicantProfile.ownCar
              "
              class="applicant-show-tab-detail-badge text"
            >
              Keine Angabe
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full md:w-1/3">
        <div class="applicant-show-tab-detail">
          <div class="applicant-show-tab-detail-headline">Führerschein</div>
          <div class="applicant-show-tab-detail-content">
            <template v-if="applicantProfile.driverLicenses[0]">
              <div
                v-for="license of applicantProfile.driverLicenses"
                :key="license.id"
                class="applicant-show-tab-detail-badge"
              >
                {{ license.name }}
              </div>
            </template>
            <div v-else class="applicant-show-tab-detail-badge text">
              Keine Angabe
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full md:w-1/3">
        <div class="applicant-show-tab-detail">
          <div class="applicant-show-tab-detail-headline">Fahrbereitschaft</div>
          <div class="applicant-show-tab-detail-content">
            <div
              v-if="applicantProfile.mobilityComment"
              class="applicant-show-tab-detail-badge text"
            >
              {{ applicantProfile.mobilityComment }}
              <template v-if="applicantProfile.mobilityRadius"
                >+ {{ applicantProfile.mobilityRadius }}km</template
              >
            </div>
            <div v-else class="applicant-show-tab-detail-badge text">
              Keine Angabe
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="applicant-show-tab-divider" />
    <div class="vx-row w-full">
      <div class="vx-col w-full md:w-1/3">
        <div class="applicant-show-tab-detail">
          <div class="applicant-show-tab-detail-headline">Wunschgehalt</div>
          <div class="applicant-show-tab-detail-content">
            <div class="applicant-show-tab-detail-badge text">
              <template v-if="applicantProfile.salaryWanted"
                >{{ applicantProfile.salaryWanted }}
              </template>
              <template v-else>Keine Angabe</template>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full md:w-1/3">
        <div class="applicant-show-tab-detail">
          <div class="applicant-show-tab-detail-headline">Verfügbar ab</div>
          <div class="applicant-show-tab-detail-content">
            <div class="applicant-show-tab-detail-badge text">
              <template v-if="applicantProfile.availibiltyCustom"
                >{{ applicantProfile.availibiltyCustom }}
              </template>
              <template v-else-if="applicantProfile.availibilty">{{
                applicantProfile.availibilty.name
              }}</template>
              <template v-else>Keine Angabe</template>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full md:w-1/3">
        <div
          v-if="
            applicantProfile.wantedJobTypes &&
              applicantProfile.wantedJobTypes[0]
          "
          class="applicant-show-tab-detail"
        >
          <div class="applicant-show-tab-detail-headline">Stellenart</div>
          <div class="applicant-show-tab-detail-content">
            <div
              v-for="jobType of applicantProfile.wantedJobTypes"
              :key="jobType.id"
              class="applicant-show-tab-detail-badge text mb-2"
            >
              {{ jobType.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

const fieldRequests = `
  id
  defaultProfile {
    id
  }
`;

const APPLICANT_QUERY = gql`
  query Applicant($id: ID!) {
    applicant(id: $id) {
      ${fieldRequests}
    }
  }
`;

export default {
  data() {
    return {
      fetchFailed: false
    };
  },
  apollo: {
    applicant: {
      query: APPLICANT_QUERY,
      // update: data => {
      //   let applicant = data.applicant;
      //   if (!applicant.contactDataCompany) {
      //     applicant.contactDataCompany = {};
      //   }

      //   if (!applicant.contactData) {
      //     applicant.contactData = { address: {} };
      //   }

      //   return data.applicant;
      // },
      // result() {
      //   this.updateCurrent();
      // },
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    },
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            mobilityMotorcycle
            mobilityPublicTransport
            mobilityBicycle
            ownCar
            driverLicenses {
              id
              name
            }
            mobilityComment
            mobilityRadius
            salaryWanted
            availibilty {
              id
              name
            }
            availibiltyCustom
            wantedJobTypes {
              id
              name
            }
          }
        }
      `,
      skip() {
        return !this.applicant;
      },
      variables() {
        return {
          id: this.applicant.defaultProfile.id
        };
      }
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.applicant;
      }
    }
  },
  methods: {}
};
</script>
